import { useAppContext } from "../../../2_ksbHub/context/appContext";

import { useBszPlannerContext } from "../context/bszPlannerContext";

export default function useBszPlannerActions() {
  const { currentUser } = useAppContext();

  const {
    createProject,
    updateProject,
    deleteProject,

    setSnackbar,
    setProjects,
  } = useBszPlannerContext();

  /**
   * =========================================================
   * ✅ SNACKBAR
   * =========================================================
   */
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };

  /**
   * =========================================================
   * ✅ SAVE PROJECT
   * =========================================================
   */
  const handleSaveProject = async ({ projectData, closeDialog }) => {
    if (!currentUser?.id) {
      return false;
    }

    try {
      if (projectData?.id) {
        await updateProject(projectData);

        showSnackbar("Projekt wurde aktualisiert");
      } else {
        await createProject(projectData);

        showSnackbar("Projekt wurde erstellt");
      }

      closeDialog?.();

      return true;
    } catch (err) {
      console.error("❌ save project failed:", err);

      showSnackbar("Fehler beim Speichern des Projekts", "error");

      return false;
    }
  };

  /**
   * =========================================================
   * ✅ DELETE PROJECT
   * =========================================================
   */
  const handleDeleteProject = async ({ project, closeDialog }) => {
    if (!project?.id) {
      return false;
    }

    let previousProjects = [];

    setProjects((prev) => {
      previousProjects = prev;

      return prev.filter((p) => p.id !== project.id);
    });

    try {
      await deleteProject(project.id);
      document.activeElement?.blur();

      showSnackbar("Projekt wurde gelöscht");

      closeDialog?.();

      return true;
    } catch (err) {
      console.error("❌ delete project failed:", err);

      setProjects(previousProjects);

      showSnackbar("Fehler beim Löschen des Projekts", "error");

      return false;
    }
  };

  /**
   * =========================================================
   * ✅ EXPORT
   * =========================================================
   */
  return {
    handleSaveProject,
    handleDeleteProject,

    showSnackbar,
    handleCloseSnackbar,
  };
}
